import React from "react";
import { cn } from "../../../helpers/cn";

type ListingHeroContentWrapperProps = React.ComponentProps<"div">;

export const ListingHeroContentWrapper = ({
  className,
  children,
  ...props
}: ListingHeroContentWrapperProps) => {
  return (
    <div className={cn("w-[100%] mx:w-[65%] xl:w-[70%]", className)} {...props}>
      {children}
    </div>
  );
};
